import React, { FC } from "react";

import { Typography, Image, Row, Column } from "../../../components";

export interface INewsLetterSuccessProps {
  successTitle?: string;
  successDescription?: string;
  successImageSrc?: string;
}

const NewsLetterSuccessSubscription: FC<INewsLetterSuccessProps> = (props) => {
  const { successTitle, successDescription, successImageSrc } = props;
  return (
    <div className="py-9 px-6 pt-lg-8 pb-lg-11 px-lg-0 border-widget">
      <Row justifyContent="justify-content-center">
        <Column xs={12} lg={4} classes={{ root: "text-center" }}>
          <Image
            classes={{ root: "mb-8" }}
            src={successImageSrc}
            alt="success"
          />
          <Typography
            classes={{ root: "mb-6" }}
            variant="mobile-header-20-bold"
            as="div"
          >
            {successTitle}
          </Typography>
          <Typography variant="p-medium" as="div">
            {successDescription}
          </Typography>
        </Column>
      </Row>
    </div>
  );
};

export default NewsLetterSuccessSubscription;
